// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Modal_Modal__IBV5H {
    position: fixed;
    z-index: 500;
    
    width: 60em !important;
    height: 27em !important;
    border: solid 4px #21929b;
    box-shadow: 1px 1px 1px black;
    
    left: 25% !important;
    top: 18%;
    box-sizing: border-box;
    transition: all 0.3s ease-out;
    background-color: 
    #525252;
    
    
}

@media only screen and (max-width: 1919px){
    .Modal_Modal__IBV5H {
        position: fixed;
        z-index: 500;
        width:55em !important;
    
        border: solid 4px #21929b;
        box-shadow: 1px 1px 1px black;
        
        left: 25% !important;
        top: 18%;
        box-sizing: border-box;
        transition: all 0.3s ease-out;
        background-color: 
        #525252;
        
        
    }  
}

@media (min-width: 600px) {
    .Modal_Modal__IBV5H {
        width: 500px;
        left: calc(50% - 250px);
    }
}

.Modal_Heading__K2G81{
    background-color: #21929b;
    height: 50px;
    
    padding :10px;
    padding-left:9em;
}

.Modal_HeadingText__gMZsR{
  font-family: Ubuntu;
  font-size: 30px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: center;
  color: #fff;
  padding: 15%;
}

.Modal_DescriptionText__rEeZc{
    font-family: Ubuntu;
  font-size: 18px;
  font-weight: bold;
  font-stretch: normal;
  font-style: normal;
  line-height: normal;
  letter-spacing: normal;
  text-align: justify;
  color: #fff;
  padding: 15px;
}






@media only screen and (min-width: 2560px){
    .Modal_Modal__IBV5H {
        position: fixed;
        z-index: 500;
        width:33% !important;
        height: 28%;
       
        border: solid 4px #21929b;
        box-shadow: 1px 1px 1px black;
        
        left: 35% !important;
        top: 15%;
        box-sizing: border-box;
        transition: all 0.3s ease-out;
        background-color: 
        #525252;
        
        
    } 
    
    
    .Modal_HeadingText__gMZsR{
        font-family: Ubuntu;
        font-size: 30px;
        font-weight: bold;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: center;
        color: #fff;
        padding: 12%;
      }
      
      .Modal_DescriptionText__rEeZc{
          font-family: Ubuntu;
        font-size: 22px;
        font-weight: normal;
        font-stretch: normal;
        font-style: normal;
        line-height: normal;
        letter-spacing: normal;
        text-align: justify;
        color: #fff;
        padding: 15px;
      }
}


@media only screen and (max-width: 1280px){
    .Modal_Modal__IBV5H {
        position: fixed;
        z-index: 500;
        width:55em !important;
    
        border: solid 4px #21929b;
        box-shadow: 1px 1px 1px black;
        
        left: 15% !important;
        top: 18%;
        box-sizing: border-box;
        transition: all 0.3s ease-out;
        background-color: 
        #525252;
        
        
    }  
}`, "",{"version":3,"sources":["webpack://./src/components/Modal.module.css"],"names":[],"mappings":"AAAA;IACI,eAAe;IACf,YAAY;;IAEZ,sBAAsB;IACtB,uBAAuB;IACvB,yBAAyB;IACzB,6BAA6B;;IAE7B,oBAAoB;IACpB,QAAQ;IACR,sBAAsB;IACtB,6BAA6B;IAC7B;WACO;;;AAGX;;AAEA;IACI;QACI,eAAe;QACf,YAAY;QACZ,qBAAqB;;QAErB,yBAAyB;QACzB,6BAA6B;;QAE7B,oBAAoB;QACpB,QAAQ;QACR,sBAAsB;QACtB,6BAA6B;QAC7B;eACO;;;IAGX;AACJ;;AAEA;IACI;QACI,YAAY;QACZ,uBAAuB;IAC3B;AACJ;;AAEA;IACI,yBAAyB;IACzB,YAAY;;IAEZ,aAAa;IACb,gBAAgB;AACpB;;AAEA;EACE,mBAAmB;EACnB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,kBAAkB;EAClB,WAAW;EACX,YAAY;AACd;;AAEA;IACI,mBAAmB;EACrB,eAAe;EACf,iBAAiB;EACjB,oBAAoB;EACpB,kBAAkB;EAClB,mBAAmB;EACnB,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,aAAa;AACf;;;;;;;AAOA;IACI;QACI,eAAe;QACf,YAAY;QACZ,oBAAoB;QACpB,WAAW;;QAEX,yBAAyB;QACzB,6BAA6B;;QAE7B,oBAAoB;QACpB,QAAQ;QACR,sBAAsB;QACtB,6BAA6B;QAC7B;eACO;;;IAGX;;;IAGA;QACI,mBAAmB;QACnB,eAAe;QACf,iBAAiB;QACjB,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,kBAAkB;QAClB,WAAW;QACX,YAAY;MACd;;MAEA;UACI,mBAAmB;QACrB,eAAe;QACf,mBAAmB;QACnB,oBAAoB;QACpB,kBAAkB;QAClB,mBAAmB;QACnB,sBAAsB;QACtB,mBAAmB;QACnB,WAAW;QACX,aAAa;MACf;AACN;;;AAGA;IACI;QACI,eAAe;QACf,YAAY;QACZ,qBAAqB;;QAErB,yBAAyB;QACzB,6BAA6B;;QAE7B,oBAAoB;QACpB,QAAQ;QACR,sBAAsB;QACtB,6BAA6B;QAC7B;eACO;;;IAGX;AACJ","sourcesContent":[".Modal {\r\n    position: fixed;\r\n    z-index: 500;\r\n    \r\n    width: 60em !important;\r\n    height: 27em !important;\r\n    border: solid 4px #21929b;\r\n    box-shadow: 1px 1px 1px black;\r\n    \r\n    left: 25% !important;\r\n    top: 18%;\r\n    box-sizing: border-box;\r\n    transition: all 0.3s ease-out;\r\n    background-color: \r\n    #525252;\r\n    \r\n    \r\n}\r\n\r\n@media only screen and (max-width: 1919px){\r\n    .Modal {\r\n        position: fixed;\r\n        z-index: 500;\r\n        width:55em !important;\r\n    \r\n        border: solid 4px #21929b;\r\n        box-shadow: 1px 1px 1px black;\r\n        \r\n        left: 25% !important;\r\n        top: 18%;\r\n        box-sizing: border-box;\r\n        transition: all 0.3s ease-out;\r\n        background-color: \r\n        #525252;\r\n        \r\n        \r\n    }  \r\n}\r\n\r\n@media (min-width: 600px) {\r\n    .Modal {\r\n        width: 500px;\r\n        left: calc(50% - 250px);\r\n    }\r\n}\r\n\r\n.Heading{\r\n    background-color: #21929b;\r\n    height: 50px;\r\n    \r\n    padding :10px;\r\n    padding-left:9em;\r\n}\r\n\r\n.HeadingText{\r\n  font-family: Ubuntu;\r\n  font-size: 30px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: center;\r\n  color: #fff;\r\n  padding: 15%;\r\n}\r\n\r\n.DescriptionText{\r\n    font-family: Ubuntu;\r\n  font-size: 18px;\r\n  font-weight: bold;\r\n  font-stretch: normal;\r\n  font-style: normal;\r\n  line-height: normal;\r\n  letter-spacing: normal;\r\n  text-align: justify;\r\n  color: #fff;\r\n  padding: 15px;\r\n}\r\n\r\n\r\n\r\n\r\n\r\n\r\n@media only screen and (min-width: 2560px){\r\n    .Modal {\r\n        position: fixed;\r\n        z-index: 500;\r\n        width:33% !important;\r\n        height: 28%;\r\n       \r\n        border: solid 4px #21929b;\r\n        box-shadow: 1px 1px 1px black;\r\n        \r\n        left: 35% !important;\r\n        top: 15%;\r\n        box-sizing: border-box;\r\n        transition: all 0.3s ease-out;\r\n        background-color: \r\n        #525252;\r\n        \r\n        \r\n    } \r\n    \r\n    \r\n    .HeadingText{\r\n        font-family: Ubuntu;\r\n        font-size: 30px;\r\n        font-weight: bold;\r\n        font-stretch: normal;\r\n        font-style: normal;\r\n        line-height: normal;\r\n        letter-spacing: normal;\r\n        text-align: center;\r\n        color: #fff;\r\n        padding: 12%;\r\n      }\r\n      \r\n      .DescriptionText{\r\n          font-family: Ubuntu;\r\n        font-size: 22px;\r\n        font-weight: normal;\r\n        font-stretch: normal;\r\n        font-style: normal;\r\n        line-height: normal;\r\n        letter-spacing: normal;\r\n        text-align: justify;\r\n        color: #fff;\r\n        padding: 15px;\r\n      }\r\n}\r\n\r\n\r\n@media only screen and (max-width: 1280px){\r\n    .Modal {\r\n        position: fixed;\r\n        z-index: 500;\r\n        width:55em !important;\r\n    \r\n        border: solid 4px #21929b;\r\n        box-shadow: 1px 1px 1px black;\r\n        \r\n        left: 15% !important;\r\n        top: 18%;\r\n        box-sizing: border-box;\r\n        transition: all 0.3s ease-out;\r\n        background-color: \r\n        #525252;\r\n        \r\n        \r\n    }  \r\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"Modal": `Modal_Modal__IBV5H`,
	"Heading": `Modal_Heading__K2G81`,
	"HeadingText": `Modal_HeadingText__gMZsR`,
	"DescriptionText": `Modal_DescriptionText__rEeZc`
};
export default ___CSS_LOADER_EXPORT___;
